import { connect } from 'react-redux';
import AdminUsersComponent from './admin-users.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminUsersComponent);



// WEBPACK FOOTER //
// ./src/components/admin/users/admin-users.ts